import { action, flow, makeObservable, observable } from "mobx";
import { API } from "aws-amplify";
// [DEPRECATED_GRAPHQL] - Para eliminación: getData usa GraphQL query getData
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import { getData } from "../../graphql/queries";

class DataStore {
    data = [];
    filteredData = [];
    totalRowCount = 0;
    isLoading = false;
    isError = false;
    currentPage = 1;
    pageSize = 10;

    constructor() {
        makeObservable(this, {
            data: observable,
            filteredData: observable,
            totalRowCount: observable,
            isLoading: observable,
            isError: observable,
            currentPage: observable,
            pageSize: observable,
            // [DEPRECATED_GRAPHQL] - Para eliminación: getData usa GraphQL query getData
            // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
            
            // getData: flow,
            setError: action,
            clearError: action,
            setPage: action,
            filterData: action,
        });
    }

    vehiclesMap = (data) => {
        if (!Array.isArray(data)) {
            console.error('vehiclesMap: data is not an array', data);
            this.data = [];
            return;
        }
        
        this.data = data.map(vehicle => ({
            id: vehicle?.id || '',
            make: vehicle?.make || '',
            model: vehicle?.model || '',
            year: vehicle?.year || '',
            vin: vehicle?.vin || '',
            owner: vehicle?.owner || '',
            color: vehicle?.color || '',
            contact_id: vehicle?.contact_id || vehicle?.id || '', // Ensure we have a contact_id for row clicks
            ...vehicle, // Include any additional fields from API
        }));
    }

    repairsMap = (data) => {
        if (!Array.isArray(data)) {
            console.error('repairsMap: data is not an array', data);
            this.data = [];
            return;
        }
        
        this.data = data.map(order => ({
            id: order?.id || '',
            roNumber: order?.ro_number || '',
            status: order?.status || '',
            description: order?.description || '',
            appointmentDay: order?.appointment_day || '',
            bookDay: order?.book_day || '',
            ...order,
        }));
    }

    appointmentsMap = (data) => {
        if (!Array.isArray(data)) {
            console.error('appointmentsMap: data is not an array', data);
            this.data = [];
            return;
        }
        
        this.data = data.map(appointment => ({
            id: appointment?.id || '',
            serviceType: appointment?.service_type || '',
            appointmentDay: appointment?.appointment_day ? new Date(appointment?.appointment_day) : null,
            appointmentTime: appointment?.appointment_time || '',
            description: appointment?.description || '',
            customer: appointment?.customer || '',
            ...appointment,
        }));
        
        // Sort safely
        if (this.data.length > 0) {
            this.data.sort((a, b) => {
                if (!a.appointmentDay || !b.appointmentDay) return 0;
                return b.appointmentDay - a.appointmentDay;
            });
        }
    };

    inventoryMap = (data) => {
        if (!Array.isArray(data)) {
            console.error('inventoryMap: data is not an array', data);
            this.data = [];
            return;
        }
        
        this.data = data.map(item => ({
            VIN: item?.vin || '',
            Stock: item?.stock || '',
            NewUsed: item?.new_used || '',
            Year: item?.year || '',
            Make: item?.make || '',
            Model: item?.model || '',
            ModelNumber: item?.model_number || '',
            Body: item?.body || '',
            Transmission: item?.transmission || '',
            Series: item?.series || '',
            BodyDoorCt: item?.body_door_ct || '',
            Odometer: item?.odometer || '',
            EngineCylinderCt: item?.engine_cylinder_ct || '',
            DrivetrainDesc: item?.drivetrain_desc || '',
            Colour: item?.colour || '',
            InteriorColor: item?.interior_color || '',
            MSRP: item?.msrp || '',
            Price: item?.price || '',
            CityMPG: item?.city_mpg || '',
            HighwayMPG: item?.highway_mpg || '',
            ...item,
        }));
    }

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getData
    // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
    
    // *getData({ customer, pageIndex, pageSize, sortBy, search, source }) {
    //     try {
    //         this.isLoading = true;
    //         this.isError = false;

    //         const validPageIndex = pageIndex !== null ? pageIndex : 0;
    //         const queryForData = getData;
    //         const mapFunctionName = `${source.toLowerCase()}Map`;

    //         const parameters = {
    //             count_records: false,
    //             page_size: pageSize || 10,
    //             page: validPageIndex + 1,
    //         };

    //         if (search && search.trim()) {
    //             parameters.search = search.trim();
    //         }

    //         if (sortBy && sortBy.length > 0) {
    //             parameters.order_by = sortBy[0];
    //         }

    //         if (parameters.page === 1) {
    //             parameters.count_records = true;
    //         }

    //         const variables = {
    //             input: {
    //                 customer: customer,
    //                 parameters: JSON.stringify(parameters),
    //                 source
    //             },
    //         };

    //         const response = yield API.graphql({
    //             query: queryForData,
    //             variables: variables,
    //             authMode: 'AMAZON_COGNITO_USER_POOLS',
    //         });

    //         // Parse the response data with error handling
    //         if (!response || !response.data || !response.data.getData || !response.data.getData.body) {
    //             console.error('Invalid response structure:', response);
    //             this.isError = true;
    //             this.data = [];
    //             this.totalRowCount = 0;
    //             return;
    //         }

    //         const body = JSON.parse(response.data.getData.body);
            
    //         if (!body || !body.data) {
    //             console.error('Invalid body structure:', body);
    //             this.isError = true;
    //             this.data = [];
    //             this.totalRowCount = 0;
    //             return;
    //         }
            
    //         let data;
    //         try {
    //             data = JSON.parse(body.data);
    //         } catch (e) {
    //             console.error('Error parsing body.data:', e);
    //             this.isError = true;
    //             this.data = [];
    //             this.totalRowCount = 0;
    //             return;
    //         }

    //         // Safety check for data being undefined or not an array
    //         if (!data || !Array.isArray(data)) {
    //             console.error('Data is not an array:', data);
    //             this.data = [];
    //             this.totalRowCount = 0;
    //             return;
    //         }

    //         // Map data to match mock data structure
    //         if (mapFunctionName && typeof this[mapFunctionName] === 'function') {
    //             this[mapFunctionName](data); // Invoke the mapping function dynamically
    //         } else {
    //             console.error('Invalid mapping function:', mapFunctionName);
    //             this.isError = true;
    //             this.data = [];
    //         }

    //         this.totalRowCount = parameters.count_records ? (body.totalRowCount || data.length) : this.totalRowCount;
    //         this.currentPage = validPageIndex + 1;

    //     } catch (error) {
    //         console.error('Error in getData:', error);
    //         this.isError = true;
    //         this.errorMessage = error.message || "An unexpected error occurred";
    //         this.data = [];
    //         throw error;
    //     } finally {
    //         this.isLoading = false;
    //     }
    // }

    setError(isError) {
        this.isError = isError;
    }

    clearError() {
        this.isError = false;
    }

    setPage(page) {
        this.currentPage = page;
    }

    filterData(filters) {
        if (!filters || filters.length === 0) {
            this.filteredData = this.data;
        } else {
            this.filteredData = this.data.filter(item =>
                filters.every(filter => item[filter.key] === filter.value)
            );
        }
    }
}

export default DataStore;
